var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"title":"Add an Invoice"},on:{"on-hide":_vm.resetFormData}},[_c('invoices-form',{key:_vm.formKey,attrs:{"date":new Date().toISOString()},on:{"on-submit":_vm.createInvoice,"on-save":_vm.redirectToInvoice,"on-cancel":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }